import axios from "axios";

const transversalApi = process.env.REACT_APP_COMFAMA_TRANSVERSAL_API;

export const getCompaniesSearch = (keyword: string) =>
  axios.get(`${transversalApi}/companies-filters?filter=${keyword}`);